"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableTBodyBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("./bc-data-table-constants");
var bc_data_table_cell_number_1 = require("./bc-data-table-cells/bc-data-table-cell-number");
var bc_data_table_cell_check_1 = require("./bc-data-table-cells/bc-data-table-cell-check");
var bc_data_table_cell_default_1 = require("./bc-data-table-cells/bc-data-table-cell-default");
var bc_data_table_cell_actions_1 = require("./bc-data-table-cells/bc-data-table-cell-actions");
var bc_data_table_cell_franchise_1 = require("./bc-data-table-cells/bc-data-table-cell-franchise");
var bc_data_table_cell_money_1 = require("./bc-data-table-cells/bc-data-table-cell-money");
var bc_data_table_cell_label_1 = require("./bc-data-table-cells/bc-data-table-cell-label");
var bc_data_table_cell_link_1 = require("./bc-data-table-cells/bc-data-table-cell-link");
var bc_data_table_cell_date_1 = require("./bc-data-table-cells/bc-data-table-cell-date");
var bc_data_table_cell_status_1 = require("./bc-data-table-cells/bc-data-table-cell-status");
var bc_data_table_header_paginator_behavior_1 = require("./bc-data-table-headers/bc-data-table-header-paginator-behavior");
var bc_data_table_header_settings_behavior_1 = require("./bc-data-table-headers/bc-data-table-header-settings-behavior");
var bc_data_table_radio_group_behavior_1 = require("./bc-data-table-radio-group-behavior");
var bc_data_table_cell_radio_1 = require("./bc-data-table-cells/bc-data-table-cell-radio");
var BcDataTableTBodyBehavior = (function () {
    function BcDataTableTBodyBehavior(bcDataTableConfig, bcDataTableMulticheckBehavior, bcDataTableRadioGroupBehavior) {
        this.bcDataTableConfig = bcDataTableConfig;
        this.bcDataTableMulticheckBehavior = bcDataTableMulticheckBehavior;
        this.bcDataTableRadioGroupBehavior = bcDataTableRadioGroupBehavior;
        this.cellTypeRenderers = {
            number: new bc_data_table_cell_number_1.BcDataTableNumberCell(),
            check: new bc_data_table_cell_check_1.BcDataTableCheckCell(this.bcDataTableMulticheckBehavior),
            radio: new bc_data_table_cell_radio_1.BcDataTableRadioCell(this.bcDataTableRadioGroupBehavior),
            action: new bc_data_table_cell_actions_1.BcDataTableActionsCell(this.bcDataTableConfig),
            franchise: new bc_data_table_cell_franchise_1.BcDataTableFranchiseCell(),
            label: new bc_data_table_cell_label_1.BcDataTableLabelCell(),
            money: new bc_data_table_cell_money_1.BcDataTableMoneyCell(),
            link: new bc_data_table_cell_link_1.BcDataTableLinkCell(),
            date: new bc_data_table_cell_date_1.BcDataTableDateCell(),
            status: new bc_data_table_cell_status_1.BcDataTableStatusCell(),
            default: new bc_data_table_cell_default_1.BcDataTableDefaultCell(),
        };
        this.bcDataTableHeaderPaginatorBehavior = new bc_data_table_header_paginator_behavior_1.BcDataTableHeaderPaginatorBehavior(this.bcDataTableConfig);
        this.bcDataTableHeaderSettingsBehavior = new bc_data_table_header_settings_behavior_1.BcDataTableHeaderSettingsBehavior(this.bcDataTableConfig);
        this.bcDataTableRadioGroupBehavior = new bc_data_table_radio_group_behavior_1.BcDataTableRadioGroupBehavior(this.bcDataTableConfig);
    }
    BcDataTableTBodyBehavior.prototype.setMultiCheck = function (dataTable) {
        if (this.bcDataTableConfig.data[0][0].type !== 'check') {
            var newObject_1 = {
                type: 'check',
                value: false,
            };
            this.bcDataTableConfig.data = this.bcDataTableConfig.data.map(function (row) { return __spreadArray([newObject_1], row, true); });
        }
    };
    BcDataTableTBodyBehavior.prototype.setRadioGroup = function () {
        if (this.bcDataTableConfig.data[0][0].type !== bc_data_table_constants_1.BcDataTableConstansts.RADIO_TYPE) {
            var newObject_2 = {
                type: bc_data_table_constants_1.BcDataTableConstansts.RADIO_TYPE,
                value: false
            };
            this.bcDataTableConfig.data = this.bcDataTableConfig.data.map(function (row) { return __spreadArray([newObject_2], row, true); });
        }
    };
    BcDataTableTBodyBehavior.prototype.getIndexColumnToSort = function () {
        var data = this.bcDataTableConfig.columnHeaders.data;
        return data.findIndex(function (item) { return item.sort !== null; });
    };
    BcDataTableTBodyBehavior.prototype.updateHtmlTableRowBySortIndex = function (dataTable, index) {
        var _this = this;
        var paginatedData = this.bcDataTableHeaderPaginatorBehavior.getPaginatedArray(this.bcDataTableConfig.data, this.bcDataTableConfig.paginationBackend);
        if (index >= 0) {
            var column = this.bcDataTableConfig.columnHeaders.data[index];
            var sort_1 = column.sort, dataType_1 = column.dataType;
            paginatedData.sort(function (a, b) {
                var valueA = a[index + 1].value;
                var valueB = b[index + 1].value;
                var compareFunction = _this.getCompareFunction(dataType_1, sort_1);
                return compareFunction(valueA, valueB);
            });
        }
        this.renderHtmlTableBody(dataTable, paginatedData, true);
    };
    BcDataTableTBodyBehavior.prototype.getCompareFunction = function (dataType, sort) {
        var _this = this;
        var compareFunctions = {
            number: function (a, b) { return _this.compareNumbers(a, b, sort); },
            money: function (a, b) { return _this.compareNumbers(a, b, sort); },
            date: function (a, b) { return _this.compareDates(a, b, sort); },
            string: function (a, b) { return _this.compareStrings(a, b, sort); },
            label: function (a, b) { return _this.compareStrings(a, b, sort); },
            franchise: function (a, b) { return _this.compareStrings(a, b, sort); },
        };
        return compareFunctions[dataType] || (function (a, b) { return _this.compareStrings(a, b, sort); });
    };
    BcDataTableTBodyBehavior.prototype.compareNumbers = function (valueA, valueB, sort) {
        var numericA = parseFloat(valueA);
        var numericB = parseFloat(valueB);
        return sort === bc_data_table_constants_1.BcDataTableConstansts.SORT_ASC ? numericA - numericB : numericB - numericA;
    };
    BcDataTableTBodyBehavior.prototype.compareDates = function (valueA, valueB, sort) {
        var dateA = new Date(valueA).getTime();
        var dateB = new Date(valueB).getTime();
        return sort === bc_data_table_constants_1.BcDataTableConstansts.SORT_ASC ? dateA - dateB : dateB - dateA;
    };
    BcDataTableTBodyBehavior.prototype.compareStrings = function (valueA, valueB, sort) {
        return sort === bc_data_table_constants_1.BcDataTableConstansts.SORT_ASC ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    };
    BcDataTableTBodyBehavior.prototype.renderHtmlTableBody = function (dataTable, dataTableData, paginated) {
        var _this = this;
        if (paginated === void 0) { paginated = false; }
        dataTable.tBodies[0].innerHTML = '';
        var paginatedData = this.bcDataTableHeaderPaginatorBehavior.getPaginatedArray(dataTableData, this.bcDataTableConfig.paginationBackend);
        if (paginated) {
            paginatedData = dataTableData;
        }
        if (paginatedData) {
            var pinnedArray = this.bcDataTableHeaderSettingsBehavior.getPinnedArray(paginatedData);
            pinnedArray.forEach(function (row) {
                var newRow = _this.createHtmlTableRow(row);
                dataTable.tBodies[0].appendChild(newRow);
            });
        }
    };
    BcDataTableTBodyBehavior.prototype.createHtmlTableRow = function (dataTableRow) {
        var _this = this;
        var newRow = document.createElement(common_constants_1.BcCommonConstants.TR_TAG);
        var idObject = dataTableRow.find(function (item) {
            if (item) {
                return item.type === 'id';
            }
        });
        if (idObject) {
            newRow.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ROW_ID, idObject.value);
        }
        if (this.bcDataTableConfig.columnHeaders) {
            var copyColumnHeader = JSON.parse(JSON.stringify(this.bcDataTableConfig.columnHeaders.data));
            var copyColumnHeaderOrder = this._orderColumnHeader(copyColumnHeader);
            return this._orderDataTableRow(copyColumnHeaderOrder, dataTableRow, newRow);
        }
        else {
            dataTableRow.forEach(function (cell, i) {
                if (cell && cell.type !== common_constants_1.BcCommonConstants.ID && cell.type !== bc_data_table_constants_1.BcDataTableConstansts.ACTION_HEADER) {
                    var newCell = _this.createCell(cell);
                    _this.rowIsSelected(i, cell, newRow);
                    newRow.appendChild(newCell);
                }
            });
            return newRow;
        }
    };
    BcDataTableTBodyBehavior.prototype._orderColumnHeader = function (copyColumnHeader) {
        if (this.bcDataTableConfig.multicheck) {
            copyColumnHeader.forEach(function (item, index) {
                if (item.pinned) {
                    var pinned = copyColumnHeader.splice(index, 1);
                    copyColumnHeader.splice(1, 0, pinned[0]);
                }
            });
        }
        else {
            copyColumnHeader.forEach(function (item, index) {
                if (item.pinned) {
                    var pinned = copyColumnHeader.splice(index, 1);
                    copyColumnHeader.unshift(pinned[0]);
                }
            });
        }
        return copyColumnHeader;
    };
    BcDataTableTBodyBehavior.prototype._orderDataTableRow = function (copyColumnHeaderOrder, dataTableRow, row) {
        var _this = this;
        var tmpInvisibleObjectIndex = copyColumnHeaderOrder
            .map(function (item, index) { return (item.visible === false && item.dataType !== 'checkAll' && item.dataType !== 'actions') ? index : undefined; })
            .filter(function (index) { return index !== undefined; });
        var invisibleObjectIndex = tmpInvisibleObjectIndex.map(function (numero) { return numero + 1; });
        dataTableRow.forEach(function (item, index) {
            if (item.type === 'id') {
                var id = dataTableRow.splice(index, 1);
                dataTableRow.unshift(id[0]);
            }
        });
        dataTableRow.forEach(function (cell, i) {
            var indice = i;
            if (cell.type !== common_constants_1.BcCommonConstants.ID && cell.type !== bc_data_table_constants_1.BcDataTableConstansts.ACTION_HEADER && !invisibleObjectIndex.includes(indice)) {
                var newCell = _this.createCell(cell);
                _this.rowIsSelected(i, cell, row);
                row.appendChild(newCell);
            }
        });
        return row;
    };
    BcDataTableTBodyBehavior.prototype.rowIsSelected = function (index, cell, newRow) {
        if (index === 0 && this.bcDataTableConfig.multicheck && typeof cell.value === 'boolean' && cell.value) {
            newRow.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TR_SELECTED_CLASS);
        }
    };
    BcDataTableTBodyBehavior.prototype.createCell = function (cell) {
        var cellRenderer = this.getCellRenderer(cell.type);
        return cellRenderer.render(cell);
    };
    BcDataTableTBodyBehavior.prototype.getCellRenderer = function (cellType) {
        return this.cellTypeRenderers[cellType] || this.cellTypeRenderers.default;
    };
    BcDataTableTBodyBehavior.prototype.addBodyStickyClass = function (dataTable) {
        var _this = this;
        this.removeBodyStickyClass(dataTable);
        var tbody = dataTable.querySelector(common_constants_1.BcCommonConstants.TBODY_TAG);
        var bodyRows = tbody.querySelectorAll(common_constants_1.BcCommonConstants.TR_TAG);
        bodyRows.forEach(function (bodyRow) {
            var bodyCells = bodyRow.querySelectorAll(common_constants_1.BcCommonConstants.TD_TAG);
            if (_this.bcDataTableConfig.multicheck || _this.bcDataTableConfig.enabledRadioGroup) {
                bodyCells[0].classList.add(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_CLASS);
                bodyCells[1].classList.add(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_WITH_CHECK_CLASS);
                bodyCells[1].classList.add(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_CLASS_SHADOW);
            }
            else {
                bodyCells[0].classList.add(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_CLASS);
                bodyCells[0].classList.add(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_CLASS_SHADOW);
            }
        });
    };
    BcDataTableTBodyBehavior.prototype.removeBodyStickyClass = function (dataTable) {
        var tbody = dataTable.querySelector(common_constants_1.BcCommonConstants.TBODY_TAG);
        var bodyRows = tbody.querySelectorAll(common_constants_1.BcCommonConstants.TR_TAG);
        bodyRows.forEach(function (bodyRow) {
            var bodyCells = bodyRow.querySelectorAll(common_constants_1.BcCommonConstants.TD_TAG);
            if (bodyCells.length > 0) {
                bodyCells[0].classList.remove(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_CLASS);
                bodyCells[0].classList.remove(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_CLASS_SHADOW);
                bodyCells[1].classList.remove(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_WITH_CHECK_CLASS);
                bodyCells[1].classList.remove(bc_data_table_constants_1.BcDataTableConstansts.STICKY_COLUMN_CLASS_SHADOW);
            }
        });
    };
    return BcDataTableTBodyBehavior;
}());
exports.BcDataTableTBodyBehavior = BcDataTableTBodyBehavior;
